<script lang="ts" setup>
import MAvatar from "../../MAvatar";
import MButton from "../../MButton";
import MLayoutStack from "../../MLayoutStack";

defineProps<{
  taskId?: string;
  taskType?: string;
  name?: string;
  initials?: string;
  description?: string;
  type?: string;
  onChange?: (v: string) => void | PromiseLike<boolean> | boolean;
  disabled?: boolean;
}>();
</script>
<template>
  <div class="assignee-button">
    <m-button
      :disabled="disabled"
      :class="disabled && 'disabled'"
      :to-modal="{
        url: `/tasks/change-assignee/${taskId}`,
        params: { taskType },
      }"
      ghost
    >
      <m-layout-stack class="items-center" horizontal gap="2">
        <MAvatar
          class="flex-0"
          :name="name"
          size="30px"
          :workspace="type === 'team'"
          :initials="initials"
        />
        <m-layout-stack class="name" gap="0" full>
          <m-layout-stack horizontal start>
            <span :title="name" data-testid="assignee-name">{{ name ?? "Unassigned" }}</span>
          </m-layout-stack>
          <m-layout-stack horizontal start>
            <span class="description" :title="description" data-testid="assignee-description">{{
              description
            }}</span>
          </m-layout-stack>
        </m-layout-stack>
      </m-layout-stack>
    </m-button>
  </div>
</template>
<style lang="scss">
.assignee-button {
  border-radius: 4px;

  padding: 2px 5px;

  &:hover > :not(.disabled) {
    background-color: var(--grey);
  }

  .q-icon {
    color: var(--grey-darkest);
  }

  .medicus-button-container {
    &.ghost {
      .medicus-button {
        font-weight: normal;
      }

      .button-content {
        text-decoration-line: none;

        .name {
          color: var(--text-color);
          overflow: hidden;
          > span {
            text-decoration: none;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .description {
            color: var(--grey-darkest);
          }
        }
      }
    }
  }
}
</style>
